<template>
  <div class="icon-container">
    <span class="icon">
      <slot></slot>
    </span>

    <div :class="['float-left', `avatar-${avatarSize}`]">
      <div>
        <span v-if="system">
          <img :src="whiteLabel || require('@/assets/images/logo-small.png')" style="display:inline-block;width: 25px;" />
        </span>
        <span v-else>
          <span v-if="!image" :class="`avatar-title rounded-circle bg-soft-${variant} text-${variant} font-size-16`">
            {{ userLetterAvatar }}
          </span>

          <img v-else :src="image" :class="[`avatar-${avatarSize}`, 'rounded-circle', 'bg-soft-secondary']" />
        </span>
      </div>
    </div>
    <div class="d-flex align-items-center">
      <span v-if="showName" class="ml-1 mt-1">
        <span v-if="summarize" v-b-tooltip.hover :title="name"> {{ name | summary }}</span>
        <span v-else> {{ name }}</span>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: ["name", "showName", "variant", "image", "system", "size", "summarize"],
  computed: {
    userLetterAvatar() {
      return this.name
        ? this.name
            .split(" ")
            .slice(0, 2)
            .map((word) => word.charAt(0).toUpperCase())
            .join("")
        : "X";
    },
    avatarSize() {
      return this.size ?? "xs";
    },
  },
};
</script>

<style scoped>
.icon {
  position: absolute;
  left: 23px;
  top: -6px;
}
.icon-container {
  position: relative;
}
</style>
